
import React from 'react';

const Mask = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='33'
			height='32'
			fill='none'
			viewBox='0 0 33 32'
		>
			<g clipPath='url(#clip0_3082:66238)'>
				<g fill='#2d2d2d' clipPath='url(#clip1_3082:66238)'>
					<path d='M16.5 22c-2.42 0-4.51-1.59-4.98-3.79l1.96-.42c.27 1.28 1.54 2.21 3.02 2.21s2.75-.93 3.02-2.21l1.96.42c-.47 2.2-2.56 3.79-4.98 3.79zM13.569 13.35c-.06-.1-.44-.35-1.07-.35-.63 0-1.01.25-1.07.35l-1.87-.7c.37-.99 1.55-1.65 2.94-1.65s2.57.66 2.94 1.65l-1.87.7zM21.569 13.35c-.06-.1-.44-.35-1.07-.35-.63 0-1.01.25-1.07.35l-1.87-.71c.37-.98 1.55-1.64 2.94-1.64s2.57.66 2.94 1.65l-1.87.7z'></path>
					<path d='M16.5 28c-6.07 0-11-4.93-11-11V6c0-.8 0-2 11-2s11 1.2 11 2v11c0 6.07-4.93 11-11 11zm-9-21.42V17c0 4.96 4.04 9 9 9s9-4.04 9-9V6.58c-1.11-.27-4.26-.58-9-.58s-7.89.31-9 .58z'></path>
				</g>
			</g>
			<defs>
				<clipPath id='clip0_3082:66238'>
					<path fill='#fff' d='M0 0H32V32H0z' transform='translate(.5)'></path>
				</clipPath>
				<clipPath id='clip1_3082:66238'>
					<path
						fill='#fff'
						d='M0 0H22V30H0z'
						transform='translate(5.5 4)'
					></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default Mask;
